var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('img',{attrs:{"src":require("../assets/404.svg"),"alt":""}}),_c('h2',[_vm._v("The page doesn't exist")])])
}]

export { render, staticRenderFns }